import { Ship, Package, Cloud, User, Briefcase, Globe2 } from "lucide-react";

const CASES = [
    {
        icon: Ship,
        tag: "Exporters",
        pain: "Inward USD payouts arrive 3–5 days late with 2–3% FX loss.",
        solution: "Receive same-day at interbank rates with auto FIRA.",
        result: "+₹1.8L saved per $1M",
    },
    {
        icon: Package,
        tag: "Importers",
        pain: "Supplier wires take days and IDPMS reconciliation is manual.",
        solution: "Pay 100+ countries <24 hrs with auto-IDPMS filing.",
        result: "−72 hrs payout cycle",
    },
    {
        icon: Cloud,
        tag: "SaaS Businesses",
        pain: "Stripe / Paypal payouts hide FX and slow INR settlement.",
        solution: "Sweep payouts into multi-currency wallet, convert when optimal.",
        result: "+1.9% net realised",
    },
    {
        icon: User,
        tag: "Freelancers",
        pain: "Banks charge ₹500–₹2000 per inward + 2% spread.",
        solution: "Flat 0.4% all-in, INR credited same day.",
        result: "₹6,000+ saved per project",
    },
    {
        icon: Briefcase,
        tag: "Agencies",
        pain: "Multiple invoices, multiple currencies, zero visibility.",
        solution: "Unified dashboard with consolidated invoicing & FIRC.",
        result: "−40% finance ops time",
    },
    {
        icon: Globe2,
        tag: "Global Service Providers",
        pain: "Cross-border vendor payouts blocked by purpose-code confusion.",
        solution: "Pre-mapped purpose codes + 15CA/CB automation.",
        result: "100% compliance, 0 chasing",
    },
];

export default function UseCases() {
    return (
        <section
            id="resources"
            data-testid="use-cases-section"
            className="bg-white py-24 md:py-32 px-4 md:px-8"
        >
            <div className="mx-auto max-w-7xl">
                <div className="max-w-2xl">
                    <span className="text-xs tracking-[0.25em] uppercase font-bold text-emerald-700">
                        Use cases
                    </span>
                    <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-zinc-950">
                        Real workflows. Real savings.
                    </h2>
                </div>

                <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {CASES.map((c, i) => (
                        <article
                            key={c.tag}
                            data-testid={`use-case-${i}`}
                            data-reveal
                            style={{ "--reveal-delay": `${(i % 3) * 80}ms` }}
                            className="reveal group rounded-2xl border border-zinc-200 bg-zinc-50 p-6 sm:p-7 hover:bg-white hover:border-emerald-300 hover:shadow-[0_24px_60px_-24px_rgba(6,78,59,0.25)] transition-all"
                        >
                            <div className="flex items-center justify-between">
                                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-zinc-950 text-white group-hover:bg-emerald-600 transition-colors">
                                    <c.icon className="h-5 w-5" />
                                </span>
                                <span className="text-[10px] tracking-[0.25em] uppercase font-bold text-emerald-700">
                                    {c.tag}
                                </span>
                            </div>
                            <div className="mt-6">
                                <div className="text-xs uppercase tracking-widest text-zinc-400 font-bold">
                                    Pain
                                </div>
                                <p className="mt-1 text-sm sm:text-base text-zinc-700">
                                    {c.pain}
                                </p>
                            </div>
                            <div className="mt-4">
                                <div className="text-xs uppercase tracking-widest text-emerald-700 font-bold">
                                    TruoPay
                                </div>
                                <p className="mt-1 text-sm sm:text-base text-zinc-800 font-medium">
                                    {c.solution}
                                </p>
                            </div>
                            <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-amber-50 text-amber-800 px-3 py-1.5 text-xs font-bold font-mono">
                                ↑ {c.result}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
